module.exports = __webpack_public_path__ + "static/img/011.5ce9b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/011.jpg
// module id = p7tP
// module chunks = 0